import React from "react"
import styled, { CSSProp, css } from "styled-components"
import { StyledIconBase } from "@styled-icons/styled-icon"

import { Element, ElementProps, elementCss } from "legacy/components/shared/base"
import { ThemeProps } from "src/legacy/theme"

interface OwnProps {
  iconColor: string
  iconHoverColor: string
  size: string | string[]
  theme: ThemeProps
}

export type IconProps = ElementProps & OwnProps

function iconStyles(props: IconProps): CSSProp {
  return css`
    color: ${props.iconColor};
    cursor: pointer;
    height: ${props.size};
    width: ${props.size};

    &:hover {
      color: ${props.iconHoverColor};
    }
  `
}

function focusStyles(props: IconProps): CSSProp {
  return css`
    &:focus {
      border-radius: ${props.theme.radii.focus};
      border: ${props.theme.borders.focus};
      box-shadow: ${props.theme.shadows.focus};
      outline: none;
    }
  `
}

const Icon = styled(({ ...props }) => {
  return <Element as="span" {...props} />
})<IconProps>`
  ${StyledIconBase} {
    ${iconStyles}
  }
  ${elementCss}
  ${focusStyles}
`

Icon.defaultProps = {
  display: "inline-block",
}

export default Icon
